import React, { Component, Fragment } from 'react';
import Navbar from '../../components/Navbar';
import Breadcrumbs from '../../components/Breadcrumbs';
export default class Page extends Component {
  render() {
    return (
      <Fragment>
        <title>PropertyHints: Buying by deadline sale</title>
        <Navbar />

        <div id="features">
          <div className="container">
            <div className="row header">
              <div className="col-md-12" align="left">
                <Breadcrumbs
                  crumbs={[
                    { url: '/ways-to-purchase', name: 'Ways to purchase' },
                    {
                      url: '/ways-to-purchase/deadline-sale',
                      name: 'Deadline Sale',
                    },
                  ]}
                />
                <h2 className="lead text-center">Deadline Sale</h2>
                <hr />
                <div className="row">
                  <div className="col-sm-12 col-md-12">
                    ​
                    <p>
                      If a property is being sold by deadline sale, the seller sets a date and buyers can make an offer
                      at any time before that date. The seller may indicate the price, and buyers can offer more or less
                      than that price and negotiate the sale.
                    </p>
                    <p>
                      A deadline sale may be advertised using the terms ‘deadline treaty’ or ‘deadline sale’. The
                      property advertising may include the words ‘unless sold prior’, which means the property can be
                      sold before the end date.
                    </p>
                    <p>
                      A sale by advertised price may be advertised using the terms ‘asking price’, ‘buyer enquiry over
                      (BEO)’, ‘buyer budget over (BBO)’ or ‘price on application (POA)’.
                    </p>
                    <p>A sale by negotiation is likely to be advertised as ‘by negotiation’.</p>
                    <p>
                      If you’re interested in a property that is being sold by deadline, let the agent know straight
                      away. The seller can accept your offer or any other offer at any time. They don’t need to wait for
                      the deadline date.
                    </p>
                    <p>
                      When you’re ready to make an offer in a deadline sale, advertised price sale or by negotiation
                      sale, talk to your lawyer or conveyancer or the agent selling the property. Your lawyer or
                      conveyancer or the agent will prepare a sale and purchase agreement for you to sign.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ways_to_purchase/DeadlineSale.jsx